// The 'Settings Updated' analytics event carries this fixed 5-flag shape. Each caller flips
// only the flag(s) for the field it changed and leaves the rest false — spread
// SETTINGS_UPDATED_FLAGS and override what changed.
export const SETTINGS_UPDATED_FLAGS = {
  token_is_updated: false,
  recaching_status_is_updated: false,
  rendering_timeout_is_updated: false,
  rendering_location_is_updated: false,
  https_status_is_updated: false,
} as const;

// -readonly: the exported constant is frozen (as const), but callers build a mutable flag
// object of this shape (spread the constant, flip what changed).
export type SettingsUpdatedFlags = { -readonly [K in keyof typeof SETTINGS_UPDATED_FLAGS]: boolean };
